import { render, staticRenderFns } from "./BrandPage.vue?vue&type=template&id=50c20439&scoped=true&"
import script from "./BrandPage.vue?vue&type=script&lang=js&"
export * from "./BrandPage.vue?vue&type=script&lang=js&"
import style0 from "./BrandPage.vue?vue&type=style&index=0&id=50c20439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c20439",
  null
  
)

export default component.exports